export default "__VITE_ASSET__CUdlrrKs__"